const init = () => {
    
    /**
     * @description renders algolia response data
     */
    window.app.SearchResults = (function() {


        /**
         * 
         * @param {obj} response JSON
         * @param {string} targetSelector where results will be appended
         * @param {boolean} isLoadingMore append or replace results
         * @param {function} onAppend callback
         */
        function render(response, targetSelector, isLoadingMore, onAppend) {

            // test collection thumbnails[]
            /*_.each(response.hits, function(hit) {
                if (hit.type === 'collection') {
                    delete hit.thumbnail;
                    hit.thumbnails = [
                        "covers/9781760894030.jpg",
                        "covers/9780241310694.jpg",
                        "covers/9780553273816.jpg"
                    ]
                }
            });*/

            var thumbnailWidth = (targetSelector.indexOf('autocomplete') > -1) ? 110 : 310;
            getThumbnails(response, thumbnailWidth);
            getSubtitles(response);
            cleanLinks(response);

            var isAutocomplete = (targetSelector.indexOf('autocomplete') > -1);
            var areResultsExhausted = ((response.page + 1) === response.nbPages);

            var nodes = Handlebars.templates['search-results']({
                response: response,
                layoutModifier: isAutocomplete ? 'autocomplete' : 'search-page',
                isAutocomplete: isAutocomplete,
                resultsExhausted: areResultsExhausted,
                seeAllUrl: window.app.state.siteUrl + 'search/?q=' + encodeURIComponent(response.query)
            });

            var $target = $(targetSelector);
            
            if (isLoadingMore) {
                var $list = $target.find('.c-search-results');
                if (!$list.length) {
                    $target.append(nodes);
                } else {
                    var $newListItems = $(nodes).find('.c-search-results__list-item');
                    $list.append($newListItems);
                }
            } else {
                $target.empty();
                $target.append(nodes);
            }

            $target.toggleClass('is-result-exhausted', areResultsExhausted);
            
            // Trigger lazy loading migration for search results
            setTimeout(function() {
                if (window.app && window.app.migrateBlazy) {
                    window.app.migrateBlazy();
                }
            }, 0);

            if (onAppend) onAppend();
        }

        function cleanLinks(response) {
            _.each(response.hits, function(hit) {
                hit.link = hit.link.replace('../', window.siteUrl);
            });
        }

        /**
         * @desc constructs thumbnail paths based on hit.type and allocates fallbacks
         * @param {array} response 
         */
        function getThumbnails(response) {
            
            // thumbnail
            _.each(response.hits, function(hit, index) {

                if (hit.initials) {
                    hit.maskId = getRandomId(8);
                }

                // collection thumbnails[]
                if (hit.type === 'collection') {
                    if (hit.thumbnails && hit.thumbnails.length) {
                        hit.thumbnails = _.map(hit.thumbnails, function(thumb) {
                            return 'https://cdn2.penguin.com.au/' + thumb.replace('covers/', 'covers/150/');
                        });
                    } else {
                        hit.thumbnails = [
                            window.siteUrl + 'img/fallback-collection.svg'
                        ]
                    }
                    return;
                }

                if (hit.thumbnail) {

                    if (hit.thumbnail.indexOf('covers/') > -1) {
                        hit.thumbnail = 'https://cdn2.penguin.com.au/' + hit.thumbnail.replace('covers/', 'covers/150/');
                        hit.thumbnailClass = 'is-cover';

                    } else if (hit.thumbnail.indexOf('authors/') > -1) {
                        hit.thumbnail = 'https://cdn2.penguin.com.au/' + hit.thumbnail.replace('authors/', 'faces/');
                        hit.thumbnailClass = 'is-author';
                        hit.initials = '';

                    } else if (hit.thumbnail.indexOf('articles/') > -1) {
                        hit.thumbnail = 'https://prh.imgix.net/' + hit.thumbnail;
                        
                    } else if (hit.thumbnail.indexOf('collection/') > -1 || hit.thumbnail.indexOf('page') > -1) {
                        hit.thumbnail = 'https://prh.imgix.net/' + hit.thumbnail;

                    } else {

                    }

                } else {
                    var fileName;
                    switch(hit.type) {
                        
                        case 'extract':
                            fileName = 'book';
                        break;

                        case 'event':
                            fileName = 'author'
                        break;

                        default:
                            fileName = hit.type;
                        break;
                    }
                    hit.thumbnail = window.siteUrl + 'img/fallback-' + fileName + '.svg';
                    
                }
            });
        }

        function getSubtitles(response) {
            _.each(response.hits, function(hit) {

                switch (hit.type) {
                    case 'book':
                        hit.subtitle = hit.author;
                    break;
                    case 'article':
                        hit.type = hit.subtitle;
                        hit.subtitle = hit.shortDescription ? hit.shortDescription.replace("'", '&quot;') : '';
                    break;
                    case 'collection':
                        // some shortDescriptions do not contain tags
                        if (hit.shortDescription) {
                            if (hit.shortDescription.indexOf('<p>') > -1) {
                                hit.subtitle = $(hit.shortDescription).text();
                            } else {
                                hit.subtitle = hit.shortDescription;
                            }
                        } else {
                            return '';
                        }
                    break;
                    case 'extract':
                        hit.subtitle = hit.author;
                    break;
                    case 'event':
                        hit.subtitle = hit.subtitle;
                    break;
                    // author
                    // page
                    default:
                        hit.subtitle = '';
                    break;
                }

            });
        }

        function getRandomId(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }

        return {
            render: render
        }

    })();

}

export default init;